<template>
    <div class="py-md-2 py-4">
        <a :href="banners.target_link" v-if="banners.id">
            <img :src="banners.banner_image_mobile" alt="Promociones" class="w-100 img-fluid d-block d-sm-none">
            <img :src="banners.banner_image_desktop" alt="Promociones" class="w-100 img-fluid d-none d-sm-block">
        </a>
    </div>
</template>
<script>
    
    export default {
        data(){
            return{
                banners: window.Valle.bannerObject
            }
        },

        props: {},

        computed: {},

        methods: {}
    }
</script>


// WEBPACK FOOTER //
// src/components/Banner.vue